import script from "./Countdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Countdown.vue?vue&type=script&setup=true&lang=js"

import "./Countdown.vue?vue&type=style&index=0&id=32317c22&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32317c22"]])

export default __exports__